export const trainingsRequestList_actionType = {
    TRAININGS_REQUEST_START: "TRAININGS_REQUEST_START",
    TRAININGS_REQUEST_SUCCESS: "TRAININGS_REQUEST_SUCCESS",
    TRAININGS_REQUEST_ERROR: "TRAININGS_REQUEST_ERROR",
    TRAININGS_REQUEST_RESET: "TRAININGS_REQUEST_RESET"
};